/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/restrictions/restrictions.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/core/point-of-sale.service.service';
import * as import6 from '../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import7 from '../../../../../public/upgrade/core/date.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '@angular/http/src/http';
import * as import12 from '@angular/router/src/router_state';
import * as import13 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import14 from '../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import15 from '../../../../../public/upgrade/core/contract.service';
import * as import16 from '@angular/core/src/zone/ng_zone';
import * as import17 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import18 from '../../../../../public/upgrade/feature/restrictions/general-settings/general-settings.component';
import * as import19 from './general-settings/general-settings.component.ngfactory';
import * as import20 from '@angular/core/src/linker/view_container';
import * as import21 from '../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import22 from '../../../../../public/upgrade/core/session.service';
import * as import23 from '../../../../../public/upgrade/shared/eva-message/eva-message.component';
import * as import24 from '../../shared/eva-message/eva-message.component.ngfactory';
import * as import25 from '../../../../../public/upgrade/feature/restrictions/special-settings/special-settings.component';
import * as import26 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import27 from './special-settings/special-settings.component.ngfactory';
import * as import28 from '../../../../../public/upgrade/root/modal/modal.service';
import * as import29 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import30 from '@angular/core/src/linker/template_ref';
import * as import31 from '@angular/common/src/directives/ng_if';
import * as import32 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import33 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import34 from '@ngx-translate/core/src/translate.pipe';
import * as import35 from '@angular/core/src/change_detection/change_detection_util';
import * as import36 from '@ngx-translate/core/src/translate.service';
import * as import37 from '@angular/forms/src/directives/ng_form';
import * as import38 from '@angular/forms/src/directives/control_container';
import * as import39 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_RestrictionsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.RestrictionsComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any) {
    this._changed = false;
    this.context = new import0.RestrictionsComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_RestrictionsComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_RestrictionsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.RestrictionsComponent>;
  _PointOfSaleA2Service_0_3:import5.PointOfSaleA2Service;
  _RestrictionsService_0_4:import6.RestrictionsService;
  _DateService_0_5:import7.DateService;
  _RestrictionsComponent_0_6:Wrapper_RestrictionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RestrictionsComponent_Host0,renderType_RestrictionsComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'restrictions',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_RestrictionsComponent0(this.viewUtils,this,0,this._el_0);
    this._PointOfSaleA2Service_0_3 = new import5.PointOfSaleA2Service(this.injectorGet(import11.Http,this.parentIndex));
    this._RestrictionsService_0_4 = new import6.RestrictionsService(this.injectorGet(import11.Http,this.parentIndex));
    this._DateService_0_5 = new import7.DateService();
    this._RestrictionsComponent_0_6 = new Wrapper_RestrictionsComponent(this.injectorGet(import12.ActivatedRoute,this.parentIndex),this.injectorGet(import13.LoadingWheelService,this.parentIndex),this._PointOfSaleA2Service_0_3,this._RestrictionsService_0_4,this._DateService_0_5,this.injectorGet(import14.SidebarService,this.parentIndex),this.injectorGet(import15.ContractService,this.parentIndex),this.injectorGet(import16.NgZone,this.parentIndex),this.injectorGet(import17.NotificationService,this.parentIndex));
    this.compView_0.create(this._RestrictionsComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._RestrictionsComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PointOfSaleA2Service) && (0 === requestNodeIndex))) { return this._PointOfSaleA2Service_0_3; }
    if (((token === import6.RestrictionsService) && (0 === requestNodeIndex))) { return this._RestrictionsService_0_4; }
    if (((token === import7.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_5; }
    if (((token === import0.RestrictionsComponent) && (0 === requestNodeIndex))) { return this._RestrictionsComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._RestrictionsComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const RestrictionsComponentNgFactory:import10.ComponentFactory<import0.RestrictionsComponent> = new import10.ComponentFactory<import0.RestrictionsComponent>('restrictions',View_RestrictionsComponent_Host0,import0.RestrictionsComponent);
const styles_RestrictionsComponent:any[] = ([] as any[]);
class View_RestrictionsComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import18.GeneralSettingsComponent>;
  _GeneralSettingsComponent_2_3:import19.Wrapper_GeneralSettingsComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_RestrictionsComponent1,renderType_RestrictionsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'general-settings',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import19.View_GeneralSettingsComponent0(this.viewUtils,this,2,this._el_2);
    this._GeneralSettingsComponent_2_3 = new import19.Wrapper_GeneralSettingsComponent(this.parentView.parentView.injectorGet(import21.FormModalService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import22.SessionService,this.parentView.parentIndex));
    this.compView_2.create(this._GeneralSettingsComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'updateGeneralRestriction',(null as any)),this.eventHandler(this.handleEvent_2));
    this._GeneralSettingsComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.GeneralSettingsComponent) && (2 === requestNodeIndex))) { return this._GeneralSettingsComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.defaultRestrictions;
    this._GeneralSettingsComponent_2_3.check_generalValues(currVal_2_0_0,throwOnChange,false);
    this._GeneralSettingsComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._GeneralSettingsComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'updateGeneralRestriction')) {
      const pd_sub_0:any = ((<any>this.parentView.context.updateGeneralSetting($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_RestrictionsComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import23.EvaMessageComponent>;
  _EvaMessageComponent_2_3:import24.Wrapper_EvaMessageComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_RestrictionsComponent2,renderType_RestrictionsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'eva-message',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import24.View_EvaMessageComponent0(this.viewUtils,this,2,this._el_2);
    this._EvaMessageComponent_2_3 = new import24.Wrapper_EvaMessageComponent();
    this.compView_2.create(this._EvaMessageComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.EvaMessageComponent) && (2 === requestNodeIndex))) { return this._EvaMessageComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.message;
    this._EvaMessageComponent_2_3.check_message(currVal_2_0_0,throwOnChange,false);
    this._EvaMessageComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_RestrictionsComponent4 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import25.SpecialSettingsComponent>;
  _GAService_0_3:import26.GAService;
  _SpecialSettingsComponent_0_4:import27.Wrapper_SpecialSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_RestrictionsComponent4,renderType_RestrictionsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'special-settings',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import27.View_SpecialSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._GAService_0_3 = new import26.GAService();
    this._SpecialSettingsComponent_0_4 = new import27.Wrapper_SpecialSettingsComponent(this.parentView.parentView.parentView.injectorGet(import12.ActivatedRoute,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import21.FormModalService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import28.ModalService,this.parentView.parentView.parentIndex),this._GAService_0_3,this.parentView.parentView.parentView.injectorGet(import22.SessionService,this.parentView.parentView.parentIndex));
    this.compView_0.create(this._SpecialSettingsComponent_0_4.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray4(4,'removeSpecialSetting',(null as any),'updatePosRestriction',(null as any)),this.eventHandler(this.handleEvent_0));
    this._SpecialSettingsComponent_0_4.subscribe(this,this.eventHandler(this.handleEvent_0),true,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_3; }
    if (((token === import25.SpecialSettingsComponent) && (0 === requestNodeIndex))) { return this._SpecialSettingsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.restrictions;
    this._SpecialSettingsComponent_0_4.check_specialValues(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parentView.parentView.context.totalPos;
    this._SpecialSettingsComponent_0_4.check_pointsOfSale(currVal_0_0_1,throwOnChange,false);
    this._SpecialSettingsComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SpecialSettingsComponent_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'removeSpecialSetting')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.removeSpecialSetting($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'updatePosRestriction')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.context.savePosRestriction($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_RestrictionsComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import20.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import29.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import20.ViewContainer) {
    super(View_RestrictionsComponent3,renderType_RestrictionsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import20.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import30.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import29.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import31.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = ((this.parentView.context.restrictions && this.parentView.context.totalPos) && this.parentView.context.result);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_RestrictionsComponent4(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
var renderType_RestrictionsComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_RestrictionsComponent,{});
export class View_RestrictionsComponent0 extends import1.AppView<import0.RestrictionsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _NgForm_4_3:import32.Wrapper_NgForm;
  _ControlContainer_4_4:any;
  _NgControlStatusGroup_4_5:import33.Wrapper_NgControlStatusGroup;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _anchor_22:any;
  /*private*/ _vc_22:import20.ViewContainer;
  _TemplateRef_22_5:any;
  _NgIf_22_6:import29.Wrapper_NgIf;
  _text_23:any;
  _anchor_24:any;
  /*private*/ _vc_24:import20.ViewContainer;
  _TemplateRef_24_5:any;
  _NgIf_24_6:import29.Wrapper_NgIf;
  _text_25:any;
  _anchor_26:any;
  /*private*/ _vc_26:import20.ViewContainer;
  _TemplateRef_26_5:any;
  _NgIf_26_6:import29.Wrapper_NgIf;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  /*private*/ _expr_43:any;
  _pipe_translate_0:import34.TranslatePipe;
  /*private*/ _expr_45:any;
  _pipe_translate_1:import34.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RestrictionsComponent0,renderType_RestrictionsComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_43 = import35.UNINITIALIZED;
    this._expr_45 = import35.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start booking-period-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'form',new import3.InlineArray2(2,'name','landingForm'),(null as any));
    this._NgForm_4_3 = new import32.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_4_4 = this._NgForm_4_3.context;
    this._NgControlStatusGroup_4_5 = new import33.Wrapper_NgControlStatusGroup(this._ControlContainer_4_4);
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'h2',new import3.InlineArray2(2,'class','eva-3-h2'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'br',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_8,'h4',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'small',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._text_20 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_21 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_22 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_22 = new import20.ViewContainer(22,6,this,this._anchor_22);
    this._TemplateRef_22_5 = new import30.TemplateRef_(this,22,this._anchor_22);
    this._NgIf_22_6 = new import29.Wrapper_NgIf(this._vc_22.vcRef,this._TemplateRef_22_5);
    this._text_23 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_24 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_24 = new import20.ViewContainer(24,6,this,this._anchor_24);
    this._TemplateRef_24_5 = new import30.TemplateRef_(this,24,this._anchor_24);
    this._NgIf_24_6 = new import29.Wrapper_NgIf(this._vc_24.vcRef,this._TemplateRef_24_5);
    this._text_25 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_26 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_26 = new import20.ViewContainer(26,6,this,this._anchor_26);
    this._TemplateRef_26_5 = new import30.TemplateRef_(this,26,this._anchor_26);
    this._NgIf_26_6 = new import29.Wrapper_NgIf(this._vc_26.vcRef,this._TemplateRef_26_5);
    this._text_27 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_28 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_29 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_30 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import34.TranslatePipe(this.parentView.injectorGet(import36.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import34.TranslatePipe(this.parentView.injectorGet(import36.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._anchor_22,
      this._text_23,
      this._anchor_24,
      this._text_25,
      this._anchor_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (22 === requestNodeIndex))) { return this._TemplateRef_22_5; }
    if (((token === import31.NgIf) && (22 === requestNodeIndex))) { return this._NgIf_22_6.context; }
    if (((token === import30.TemplateRef) && (24 === requestNodeIndex))) { return this._TemplateRef_24_5; }
    if (((token === import31.NgIf) && (24 === requestNodeIndex))) { return this._NgIf_24_6.context; }
    if (((token === import30.TemplateRef) && (26 === requestNodeIndex))) { return this._TemplateRef_26_5; }
    if (((token === import31.NgIf) && (26 === requestNodeIndex))) { return this._NgIf_26_6.context; }
    if (((token === import37.NgForm) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._NgForm_4_3.context; }
    if (((token === import38.ControlContainer) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._ControlContainer_4_4; }
    if (((token === import39.NgControlStatusGroup) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._NgControlStatusGroup_4_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import35.ValueUnwrapper();
    this._NgForm_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatusGroup_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_22_0_0:any = this.context.defaultRestrictions;
    this._NgIf_22_6.check_ngIf(currVal_22_0_0,throwOnChange,false);
    this._NgIf_22_6.ngDoCheck(this,this._anchor_22,throwOnChange);
    const currVal_24_0_0:any = ((this.context.totalPos.length == 0) && this.context.showMessage);
    this._NgIf_24_6.check_ngIf(currVal_24_0_0,throwOnChange,false);
    this._NgIf_24_6.ngDoCheck(this,this._anchor_24,throwOnChange);
    const currVal_26_0_0:any = (((this.context.restrictions && this.context.totalPos) && this.context.result) && !this.context.showMessage);
    this._NgIf_26_6.check_ngIf(currVal_26_0_0,throwOnChange,false);
    this._NgIf_26_6.ngDoCheck(this,this._anchor_26,throwOnChange);
    this._vc_22.detectChangesInNestedViews(throwOnChange);
    this._vc_24.detectChangesInNestedViews(throwOnChange);
    this._vc_26.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_4_5.checkHost(this,this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_43:any = import3.inlineInterpolate(1,'\n                        ',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_43,currVal_43))) {
      this.renderer.setText(this._text_11,currVal_43);
      this._expr_43 = currVal_43;
    }
    valUnwrapper.reset();
    const currVal_45:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.SUBTITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_45,currVal_45))) {
      this.renderer.setText(this._text_18,currVal_45);
      this._expr_45 = currVal_45;
    }
  }
  destroyInternal():void {
    this._vc_22.destroyNestedViews();
    this._vc_24.destroyNestedViews();
    this._vc_26.destroyNestedViews();
    this._NgForm_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 22)) { return new View_RestrictionsComponent1(this.viewUtils,this,22,this._anchor_22,this._vc_22); }
    if ((nodeIndex == 24)) { return new View_RestrictionsComponent2(this.viewUtils,this,24,this._anchor_24,this._vc_24); }
    if ((nodeIndex == 26)) { return new View_RestrictionsComponent3(this.viewUtils,this,26,this._anchor_26,this._vc_26); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_4_3.handleEvent(eventName,$event) && result);
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/restrictions.component.ngfactory.ts